import Loadable from 'react-loadable';
import React from 'react';
import { message, Spin } from 'antd';
import HomePage from '@/components/homePage/homePage';
import CircleBook from '@/components/CircleBook';
import Polyline from '@/components/Polyline';
import projectTasks from '@/components/projectTasks';
function MyLoadingComponent({ error, pastDelay }) {
    if (error) {
        console.log(error)
        return <div>加载错误,请重新刷新！</div>; // 加载错误时的提示模块
    } else if (pastDelay) {
        return <Spin spinning={true} tip="加载中"><div style={{ height: '300px' }}></div></Spin>;
    } else {
        return null; // 加载时间短于pastDelay（默认200ms）则不显示Loading动画
    }
}

//标记： 在定义我们的路由对象，使用react-loadable 对路由组件进行懒加载，这是经常需要做的行为。
// 详情请参考这一篇文章：https://blog.csdn.net/China_Guanq/article/details/82194928#loadable
const loadable = (filename, type) => Loadable({
    loader: () => import(`@/${type === 1 ? 'components' : 'views'}/${filename}`),
    loading: MyLoadingComponent,
    delay: 50,
});

let routers = [
    {
        key: 'UserCenter',
        name: '个人中心',
        breadcrumb: true,
        component: loadable('userCenter/userCenter'),
        path: '/userCenter',
    }, {
        key: 'homePage',
        name: '大牛Lab实验室',
        component: loadable('homePage/homePage', 1),
        path: '/homePage',
        children: [
            {
                path: '/CircleBook',
                component: CircleBook
            },
            {
                path: '/Polyline',
                component: Polyline
            },
            {
                path: '/projectTasks',
                component: projectTasks
            }
        ]
    }, {
        key: 'project1',
        name: '课题项目',
        breadcrumb: true,
        component: loadable('project2/project1'),
        path: '/project1',
    }, {
        key: 'project_child2',
        name: '课题项目',
        // breadcrumb: true,
        component: loadable('project2/project_child2'),
        path: '/project_child2/:proId',
    }, {
        key: 'project2_document',
        name: '课题资料',
        // breadcrumb: true,
        component: loadable('project2/project2_document'),
        path: '/project2_document',
    }, {
        key: 'createTopic',
        name: '新建课题',
        // breadcrumb: true,
        component: loadable('project2/createTopic'),
        path: '/createTopic',
    }, {
        key: 'createTopic1',
        name: '编辑课题',
        // breadcrumb: true,
        component: loadable('project2/createTopic'),
        path: '/createTopic1/:eqit',
    }, {
        key: 'createNum2',
        name: '子项目创建',
        // breadcrumb: true,
        component: loadable('project2/createNum2'),
        path: '/createNum2',
    }, {
        key: 'project_task2',
        name: '子项目任务',
        // breadcrumb: true,
        component: loadable('project2/project_task2'),
        path: '/project_task2/:proId/:indexId',
    }, {
        key: 'report_list',
        name: '任务汇报',
        // breadcrumb: true,
        component: loadable('project2/report_list'),
        path: '/report_list/:jobId/:proId',
    }, {
        key: 'jobReport',
        name: '工作汇报',
        // breadcrumb: true,
        component: loadable('project2/jobReport'),
        path: '/jobReport',
    }, {
        key: 'job_perpleReport',
        name: '工作汇报',
        // breadcrumb: true,
        component: loadable('project2/job_perpleReport'),
        path: '/job_perpleReport',
    }, {
        key: 'newReport',
        name: '工作汇报子页面',
        // breadcrumb: true,
        component: loadable('project2/newReport'),
        path: '/newReport/:proId',
    }, {
        key: 'research',
        name: '科研成果',
        // breadcrumb: true,
        component: loadable('research/research'),
        path: '/research',
    },





    {
        key: 'projects',
        name: '课题项目',
        breadcrumb: true,
        component: loadable('projects/projects'),
        path: '/projects',
    }, {
        key: 'project_add',
        name: '新增项目',
        component: loadable('projects/project_add'),
        path: '/project_add/:parentId/:parentName/:indexId',
    }, {
        key: 'project_edit',
        name: '修改项目',
        component: loadable('projects/project_edit'),
        path: '/project_edit/:proId/:indexId',
    }, {
        key: 'project_info',
        name: '项目详情',
        breadcrumb: true,
        component: loadable('projects/project_info'),
        path: '/project_info',
    }, {
        key: 'Project_task',
        name: '项目任务',
        component: loadable('projects/project_task'),
        path: '/project_task/:proId/:indexId',
    }, {
        key: 'projects_child',
        name: '子项目管理',
        // breadcrumb: true,
        component: loadable('projects/projects_child'),
        path: '/projects_child/:proId',
    }, {
        key: 'project_document',
        name: '项目文档',
        component: loadable('projects/project_document'),
        path: '/project_document/:proId/:indexId',
    }, {
        key: 'projectMain',
        name: '项目管理',
        breadcrumb: true,
        component: loadable('projects/project_main'),
        path: '/projectMain/:proId',
        exact: true
    }, {
        key: 'harvest_add',
        name: '新增成果',
        component: loadable('projects/harvest_add'),
        path: '/harvest_add/:indexId',
    }, {
        key: 'harvest_list',
        name: '成果管理',
        component: loadable('projects/harvest_list'),
        path: '/harvest_list/:proId/:indexId',
    }, {
        key: 'harvest_edit',
        name: '修改成果',
        component: loadable('projects/harvest_edit'),
        path: '/harvest_edit/:id/:proId/:indexId',
    }, {
        key: 'medicine',
        name: '试剂耗材库',
        breadcrumb: true,
        component: loadable('medicine/medicine'),
        path: '/medicine',
        exact: true
    }, {
        key: 'medicine_add',
        name: '新品入库',
        component: loadable('medicine/medicine_add'),
        path: '/medicine_add',
        exact: true
    }, {
        key: 'medicine_audit',
        name: '试剂耗材审批',
        component: loadable('medicine/medicine_audit'),
        path: '/medicine/:auditType',
        exact: true
    }, {
        key: 'medicine_auditInfo',
        name: '试剂耗材审批详情',
        component: loadable('medicine/medicine_auditInfo'),
        path: '/medicine/:auditType/:type/:opNo',
    }, {
        key: 'medicine_info',
        name: '试剂耗材详情',
        component: loadable('medicine/medicine_info'),
        path: '/medicine_info/:id',
    }, {
        key: 'audi_enterIn',
        name: '入库详情',
        component: loadable('medicine/audi_enterIn'),
        path: '/audi_enterIn/:id',
        exact: true
    }, {
        key: 'instrument',
        name: '仪器设备',
        breadcrumb: true,
        component: loadable('medicine/instrument'),
        path: '/instrument',
    }, {
        key: 'attendance',
        name: '考勤管理',
        breadcrumb: true,
        component: loadable('personnel/attendance'),
        path: '/attendance',
    }, {
        key: 'askForLeave',
        name: '请假管理',
        breadcrumb: true,
        component: loadable('personnel/askForLeave'),
        path: '/askForLeave',
    }, {
        key: 'training',
        name: '培训/会议',
        breadcrumb: true,
        component: loadable('personnel/training'),
        path: '/training',
    }, {
        key: 'notification',
        name: "通知管理",
        breadcrumb: true,
        component: loadable('personnel/notification'),
        path: '/notification'
    }, {
        key: 'personAdmin',
        name: '通讯录',
        breadcrumb: true,
        component: loadable('personnel/personAdmin'),
        path: '/personAdmin',
    }, {
        key: 'linkGroup',
        name: '联系人管理',
        breadcrumb: true,
        component: loadable('personnel/linkGroup'),
        path: '/linkGroup',
    }, {
        key: 'orgsAdmin',
        name: '机构管理',
        breadcrumb: true,
        component: loadable('system/org_admin'),
        path: '/orgsAdmin',
    }, {
        key: 'lab_platform',
        name: '实验室管理(平台)',
        breadcrumb: true,
        component: loadable('system/lab_platform'),
        path: '/lab_platform',
    }, {
        key: 'accountList',
        name: '账户管理',
        component: loadable('system/lab_platformAccount'),
        path: '/accountList/:lab',
    }, {
        key: 'lab_lab',
        name: '实验室管理(实验室)',
        breadcrumb: true,
        component: loadable('system/lab_lab'),
        path: '/lab_lab',
    }, {
        key: 'lab_audit',
        name: '实验室管理(平台申请)',
        breadcrumb: true,
        component: loadable('system/lab_audit'),
        path: '/lab_audit',
    }, {
        key: 'lab_userAdd',
        name: '实验室成员',
        component: loadable('system/lab_user_add'),
        path: '/lab_userAdd',
    }, {
        key: 'lab_xy',
        name: '信用详情',
        component: loadable('system/lab_user_xy'),
        path: '/lab_xy',
    }, {
        key: 'notice',
        name: '公告管理',
        breadcrumb: true,
        component: loadable('system/notice'),
        path: '/notice',
    }, {
        key: 'suggestList',
        name: '反馈管理',
        breadcrumb: true,
        component: loadable('system/suggestList'),
        path: '/suggestList',
    }, {
        key: 'msg',
        name: '消息中心',
        breadcrumb: true,
        component: loadable('msg/msg', 1),
        path: '/msg',
    }, {
        key: 'statistic',
        name: '设备统计',
        breadcrumb: true,
        component: loadable('statistical/statistical'),
        path: '/statistic',
    }, {
        key: 'statistic_project',
        name: '课题统计',
        breadcrumb: true,
        component: loadable('statistical/project'),
        path: '/statistic_project',
    }, {
        key: 'statistic_consume',
        name: '耗材统计',
        breadcrumb: true,
        component: loadable('statistical/consume'),
        path: '/statistic_consume',
    }, {
        key: 'statistic_person',
        name: '人员统计',
        breadcrumb: true,
        component: loadable('statistical/person'),
        path: '/statistic_person',
    }, {
        key: 'eqAdmin',
        name: '设备管理',
        // breadcrumb: true,
        component: loadable('equipment/eqAdminList'),
        path: '/eqAdmin',
    }, {
        key: 'eqAdd',
        name: '设备新增',
        component: loadable('equipment/eqAdd'),
        path: '/eqAdd',
    }, {
        key: 'eqAdd1',
        name: '设备修改',
        component: loadable('equipment/eqAdd'),
        path: '/eqAdd1/:type',
    }, {
        key: 'eqRecord',
        name: '设备记录',
        component: loadable('equipment/eqRecord'),
        path: '/eqRecord/:type',
        exact: true
    }, {
        key: 'eqInfo',
        name: '设备详情',
        component: loadable('equipment/eqInfo'),
        path: '/eqInfo/:id',
        exact: true
    }, {
        key: 'eqAppoint',
        name: '仪器设备库',
        breadcrumb: true,
        component: loadable('equipment/eqAppoint'),
        path: '/eqAppoint',
    }, {
        key: 'eqAppointSubmit',
        name: '预约申请',
        component: loadable('equipment/eqAppointSubmit'),
        path: '/eqAppointSubmit',
        exact: true
    }, {
        key: 'eqUserAppoint',
        name: '预约记录',
        component: loadable('equipment/eqUserAppoint'),
        path: '/eqUserAppoint',
    }, {
        key: 'eqUserAppointInfo',
        name: '预约申请',
        component: loadable('equipment/eqUserAppointInfo'),
        path: '/eqUserAppointInfo',
    }, {
        key: 'eqAudit',
        name: '预约审批',
        component: loadable('equipment/eqAuditList'),
        path: '/eqAudit',
    }, {
        key: 'eqAuditInfo',
        name: '审批详情',
        component: loadable('equipment/eqAuditInfo'),
        path: '/eqAuditInfo',
    }, {
        name: '预约记录',
        key: 'eqAuditUser',
        component: loadable('equipment/eqAuditUser'),
        path: '/eqAuditUser',
    }, {
        name: '使用信息',
        key: 'eqAuditUser2',
        component: loadable('equipment/eqAuditUser'),
        path: '/eqAuditUser2',
    }, {
        key: 'eqUse',
        name: '设备使用',
        // breadcrumb: true,
        component: loadable('equipment/eqUseList'),
        path: '/eqUse',
    }, {
        key: 'eqUseReturn',
        name: "归还单",
        component: loadable('equipment/eqUseReturn'),
        path: '/eqUseReturn',
    }, {
        key: 'eqUseEvalute',
        name: '归还单评价',
        component: loadable('equipment/eqUseEvalute'),
        path: '/eqUseEvalute',
    }, {
        key: 'qtAdd',
        name: '发起问卷',
        component: loadable('questionnaire/addQuestional'),
        path: '/qtAdd',
    }, {
        key: 'qtEdit',
        name: '修改问卷',
        component: loadable('questionnaire/editQuestional'),
        path: '/qtEdit',
    }, {
        key: 'qtAdmin',
        name: '问卷调查',
        breadcrumb: true,
        component: loadable('questionnaire/qtAdmin'),
        path: '/qtAdmin',
    }, {
        key: 'qtMy',
        name: '我的问卷',
        // breadcrumb: true,
        component: loadable('questionnaire/qtMy'),
        path: '/qtMy',
    }, {
        key: 'qtInfo',
        name: '问卷详情',
        component: loadable('questionnaire/qtInfo'),
        path: '/qtInfo',
    }, {
        key: 'repairApplyList',
        name: '故障报修',
        // breadcrumb: true,
        component: loadable('equipment/repairList'),
        path: '/repairApplyList',
    }, {
        key: 'repairApplyAdmin',
        name: '故障管理',
        breadcrumb: true,
        component: loadable('equipment/repairAdmin'),
        path: '/repairApplyAdmin',
    }, {
        key: 'meetingAppoint',
        name: '会议室预约',
        breadcrumb: true,
        component: loadable('equipment/meetingAppoint'),
        path: '/meetingAppoint',
    }, {
        key: 'meetingAppointSubmit',
        name: '会议室预约申请',
        breadcrumb: true,
        component: loadable('equipment/meetingAppointSubmit'),
        path: '/meetingAppointSubmit',
        exact: true
    }, {
        key: 'meetingAudit',
        name: '会议室预约审批列表',
        breadcrumb: true,
        component: loadable('equipment/meetingAuditList'),
        path: '/meetingAudit',
    }, {
        key: 'meetingUse',
        name: '会议室使用列表',
        breadcrumb: true,
        component: loadable('equipment/meetingUseList'),
        path: '/meetingUse',
    }, {
        key: 'meetingList',
        name: '会议室预约列表',
        breadcrumb: true,
        component: loadable('equipment/meetingUserAppoint'),
        path: '/meetingList',
    }, {
        key: 'cwDistrubute',
        name: '报账审批分配',
        // breadcrumb: true,
        component: loadable('expenseApprove/distribute'),
        path: '/cwDistrubute',
    }, {
        key: 'statistics',
        name: '经费统计',
        breadcrumb: true,
        component: loadable('statistical/statisticsList'),
        path: '/statistics',
    }, {
        key: 'statisticsList2',
        name: '经费统计',
        breadcrumb: true,
        component: loadable('statistical/statisticsList2'),
        path: '/statisticsList2',
    }, {
        key: 'cwDistrubuteDetail',
        name: '报账审批明细列表',
        component: loadable('expenseApprove/distribute_detailList'),
        path: '/cwDistrubuteDetail',
    }, {
        key: 'cwDistrubuteDetailInfo',
        name: '报账审批明细详情',
        component: loadable('expenseApprove/distribute_detailInfo'),
        path: '/cwDistrubuteDetailInfo',
    }, {
        key: 'cwApplication',
        name: '经费报账',
        breadcrumb: true,
        component: loadable('expenseApprove/application'),
        path: '/csApplication',
    }, {
        key: 'cwApplicationInfo',
        name: '报账申请详情',
        breadcrumb: true,
        component: loadable('expenseApprove/application_info'),
        path: '/cwApplicationInfo',
    }, {
        key: 'cwApplicationApply',
        name: '报账申请',
        breadcrumb: false,
        component: loadable('expenseApprove/application_form'),
        path: '/cwApplicationApply',
    }, {
        key: 'cwAudit',
        name: '报账审核列表',
        // breadcrumb: true,
        component: loadable('expenseApprove/audit'),
        path: '/cwAudit',
    }, {
        key: 'cwAuditInfo',
        name: '报账审核',
        component: loadable('expenseApprove/audit_info'),
        path: '/cwAuditinfo',
    }, {
        key: 'cwBillLibrary',
        name: '发票库',
        // breadcrumb: true,
        component: loadable('expenseApprove/billLibrary'),
        path: '/cwBillLibrary',
    }, {
        key: 'cwBillInfo',
        name: '发票详情',
        component: loadable('expenseApprove/billLibrary_info'),
        path: '/cwBillInfo',
    },
    {
        key: 'pDiskFileList',
        name: '文件私盘',
        breadcrumb: true,
        component: loadable('privateDisk/fileList'),
        path: '/pDiskFileList',
    },
    {
        key: 'pDiskFileInfo',
        name: '文件详情',
        breadcrumb: true,
        component: loadable('privateDisk/fileInfo'),
        path: '/pDiskFileInfo',
    },
    {
        key: 'pDiskApplication',
        name: '共享盘申请',
        // breadcrumb: true,
        component: loadable('privateDisk/application'),
        path: '/pDiskApplication',
    },
    {
        key: 'privateDiskApply',
        name: '共享盘申请',
        breadcrumb: false,
        component: loadable('privateDisk/application_form'),
        path: '/privateDiskApply',
    },
    {
        key: 'privateDiskAppInfo',
        name: '共享盘申请详情',
        breadcrumb: false,
        component: loadable('privateDisk/application_info'),
        path: '/privateDiskAppInfo',
    },
    {
        key: 'pDiskAudit',
        name: '共享盘审核',
        // breadcrumb: true,
        component: loadable('privateDisk/audit'),
        path: '/pDiskAudit',
    },
    {
        key: 'privateDiskAuditInfo',
        name: '共享盘审核',
        breadcrumb: false,
        component: loadable('privateDisk/audit_info'),
        path: '/privateDiskAuditInfo',
    }, {
        key: '/pDiskManage',
        name: '空间管理',
        // breadcrumb: true,
        component: loadable('privateDisk/manage'),
        path: '/pDiskManage',
    }, {
        key: '/pDiskManage_manage',
        name: '共享盘管理',
        breadcrumb: true,
        component: loadable('privateDisk/manage_manage'),
        path: '/pDiskManage_manage',
    }, {
        key: '/pDiskManage_info',
        name: '共享盘管理详情',
        breadcrumb: false,
        component: loadable('privateDisk/manage_info'),
        path: '/pDiskManage_info',
    }, {
        key: 'annualReportAdd',
        name: '填写年报',
        // breadcrumb:true,
        component: loadable('annualReport/detail'),
        path: '/annualReportAdd',
    }, {
        key: 'annualReport',
        name: '年报成果',
        // breadcrumb: true,
        component: loadable('annualReport/manage'),
        path: '/annualReport',
    }, {
        key: 'management',
        name: '报告管理',
        // breadcrumb: true,
        component: loadable('reportManagement/management'),
        path: '/management',
    }, {
        key: 'managementReview',
        name: '报告审核',
        // breadcrumb: true,
        component: loadable('reportManagement/managementReview'),
        path: '/managementReview',
    }, {
        key: 'managementReview_children',
        name: '报告审核子界面',
        // breadcrumb: true,
        component: loadable('reportManagement/managementReview_children'),
        path: '/managementReview_children/:proId',
    }, {
        key: 'management_children',
        name: '报告管理子界面',
        // breadcrumb: true,
        component: loadable('reportManagement/management_children'),
        path: '/management_children/:proId',
    }, {
        key: 'myReport',
        name: '我的报告',
        // breadcrumb: true,
        component: loadable('reportManagement/myReport'),
        path: '/myReport',
    }, {
        key: 'annualReport_audit',
        name: '年报审核',
        // breadcrumb: true,
        component: loadable('annualReport/audit'),
        path: '/annualReport_audit',
    }, {
        key: 'annualReport_auditInfo',
        name: '年报审核详情',
        component: loadable('annualReport/detail'),
        path: '/annualReport_auditInfo',
    }, {
        key: 'annualReport_info',
        name: '年报详情',
        component: loadable('annualReport/detail'),
        path: '/annualReport_info',
    }, {
        key: 'fundManagement',
        name: '经费管理',
        component: loadable('fundReimbursement/fundManagement'),
        path: '/fundManagement',
    }, {
        key: 'funding',
        name: '经费创建',
        component: loadable('fundReimbursement/funding'),
        path: '/funding',
    }, {
        key: 'fundManagementchild',
        name: '经费管理子页面',
        component: loadable('fundReimbursement/fundManagementchild'),
        path: '/fundManagementchild/:getId'
    }, {
        key: 'Detail',
        name: '经费明细',
        component: loadable('fundReimbursement/Detail'),
        path: '/Detail'
    }, {
        key: 'myReimbursement',
        name: '我的报账',
        component: loadable('fundReimbursement/myReimbursement'),
        path: '/myReimbursement'
    }, {
        key: 'Application',
        name: '报账申请',
        component: loadable('fundReimbursement/Application'),
        path: '/Application'
    }, {
        key: 'accountingApproval',
        name: '报账审批',
        component: loadable('fundReimbursement/accountingApproval'),
        path: '/accountingApproval'
    }, {
        key: 'Moneybank',
        name: '发票单据库',
        component: loadable('fundReimbursement/Moneybank'),
        path: '/Moneybank'
    }, {
        key: "myList",
        name: '工作清单',
        component: loadable('workList/myList'),
        path: '/myList'
    }, {
        key: 'weekTocreate',
        name: '日历',
        component: loadable('workList/weekTocreate'),
        path: '/weekTocreate'
    }, {
        key: 'fundCheck',
        name: '国自基金大数据',
        component: loadable('guoziFund/fundCheck'),
        path: '/fundCheck'
    }, {
        key: 'fundChecKChild',
        name: '项目详情',
        component: loadable('guoziFund/fundChecKChild'),
        path: '/fundChecKChild'
    }, {
        key: 'roundStart',
        name: '圆',
        component: loadable('round/roundStart'),
        path: '/roundStart'
    }
]

export default routers;